import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCustomImage = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 44,
	height: 44,
	viewBox: "0 0 44 44",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("filter", {
		id: "saturate",
		filterUnits: "objectBoundingBox",
		children: /* @__PURE__ */ _jsx("feColorMatrix", {
			type: "saturate",
			in: "SourceGraphic",
			values: .2
		})
	}), /* @__PURE__ */ _jsx("path", {
		d: "M34.7605 4.0788L34.6337 3.97313L34.4646 3.8886C30.8109 1.34954 26.4663 -0.00769581 22.017 3.28248e-05C16.769 -0.00401313 11.6923 1.86813 7.70348 5.27854C3.71461 8.68894 1.07628 13.4129 0.264704 18.5978C-0.546874 23.7828 0.521768 29.087 3.27774 33.5531C6.03371 38.0193 10.2954 41.3531 15.2937 42.9529C20.292 44.5527 25.6975 44.313 30.5345 42.2771C35.3716 40.2412 39.3215 36.5433 41.6714 31.8507C44.0213 27.1582 44.6162 21.7802 43.3489 16.6874C42.0816 11.5947 39.0356 7.12278 34.7605 4.0788ZM22.017 27.0509C21.0138 27.0509 20.0332 26.7535 19.1991 26.1961C18.365 25.6388 17.7149 24.8467 17.331 23.9199C16.9471 22.9931 16.8467 21.9733 17.0424 20.9894C17.2381 20.0055 17.7212 19.1017 18.4305 18.3924C19.1399 17.6831 20.0436 17.2 21.0275 17.0043C22.0114 16.8086 23.0312 16.909 23.958 17.2929C24.8848 17.6768 25.6769 18.3269 26.2342 19.161C26.7916 19.9951 27.089 20.9757 27.089 21.9789C27.0835 23.3224 26.5473 24.6092 25.5973 25.5592C24.6473 26.5092 23.3605 27.0454 22.017 27.0509ZM40.6145 21.9789C40.6145 22.5072 40.5933 23.0144 40.5511 23.5216L30.4704 21.7464C30.4135 19.6629 29.5851 17.6746 28.1457 16.1672L34.0208 7.77716C36.0874 9.52168 37.7482 11.6964 38.887 14.1494C40.0259 16.6024 40.6155 19.2744 40.6145 21.9789Z",
		fill: "#685BC7",
		filter: "url(#saturate)"
	})]
});
export default SvgCustomImage;
